import { render } from "./small.vue?vue&type=template&id=688b05ee&scoped=true"
import script from "./small.vue?vue&type=script&lang=js"
export * from "./small.vue?vue&type=script&lang=js"

import "./small.vue?vue&type=style&index=0&id=688b05ee&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688b05ee"]])

export default __exports__